import propTypes from 'prop-types';
import React from 'react';
import {
  REDEEM_BCOR_MESSAGE,
  REDEEM_BCOR_GIFT_MESSAGE,
} from '../../config/text/text';

export default function VoucherBcorRedeemMessage({ giftType }) {
  let message = REDEEM_BCOR_MESSAGE;
  if (giftType) message = REDEEM_BCOR_GIFT_MESSAGE;

  return (
    <>
      <p className="redeem">{message}</p>
      <style jsx>{`
        .redeem {
          font-size: 12px;
          margin: 10px 0 4px 0;
        }
      `}</style>
    </>
  );
}

VoucherBcorRedeemMessage.propTypes = {
  giftType: propTypes.string,
};
